import axios from 'axios';
import {useAuth} from "../authentication";
import {useEffect} from "react";
import {Router} from "react-router-dom";

export const httpClient = axios.create({
  baseURL: `${process.env.PUBLIC_URL}`, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});


export const AxiosInterceptor = ({ store, children }) => {

  // const navigate = useNavigate();
  const {userSignOut, refreshToken, logout} = useAuth();


  useEffect(() => {

    // console.log("AxiosInterceptor")
    const reqInterceptor = httpClient.interceptors.request.use(
      (conf) => {
        // console.log("startProgress")
        // store.dispatch(startProgress());
        return conf;
      }
    );


    const resInterceptor = httpClient.interceptors.response.use(
      (response) => {
        // console.log("successProgress")
        // store.dispatch(successProgress());
        return response;
      },
      (error) => {
        // console.log("errorProgress")
        // store.dispatch(errorProgress(error));
        // console.log("error : ", error)
        // TODO 특정 에러코드일 경우 강제 로그아웃. 일단은 401일 경우 무조건 로그아웃 하도록 처리.
        if(!error.response){
          error.response = {
            data : {
              error : "알수 없는 에러가 발생하였습니다.",
              error_description : error.stack,
              message: "알수 없는 에러가 발생하였습니다. : " + error.stack
            }
          }
          // errorMessage(error.response.data.message, ()=>{});
        } else if (error.response.status === 401) {
          logout()
        } else if (error.response.status === 403) {
          // errorMessage(error.response.data.detail, ()=>{});
        }  else if (error.response.status === 404) {
          // errorMessage("요청하신 페이지가 존재하지 않습니다.(" + error.request.responseURL + ")" , ()=>{Router.back();});
        }
        else {
          error.response.data = { ...error.response.data,
            message : error.response.data.detail ? error.response.data.detail : error.response.data.error_description
          }
        }

        /*if (error.response.status === 401) {
          store.dispatch({"type" : "USER_LOGGED_OUT"})
          if (error.response.data && error.response.data.error === "Connection Reset") {

          //  sessionLimitMessage(() => userSignOut());
          }
          else if (error.response.data.detail === "자격 인증데이터(authentication credentials)가 제공되지 않았습니다.") {
            //리프레시 토큰확인해야함
            refreshToken();
            //   sessionLimitMessage(() => userSignOut());
          } else {
            message.error({
              content: '401 unauthorized error',
              duration: 2,
              style: {
                marginTop: '50%',
              },
            });
            userSignOut()
          }
        } else if (error.response.status === 403) {
          errorMessage(error.response.data.detail, ()=>{});
        }
        // else if (error.response.status === 404) {
        //   errorMessage("요청하신 페이지가 존재하지 않습니다.(" + error.request.responseURL + ")" , ()=>{Router.back();});
        // }
        else if(!error.response){
          error.response = {
            data : {
              error : "알수 없는 에러가 발생하였습니다.",
              error_description : error.stack,
              message: "알수 없는 에러가 발생하였습니다. : " + error.stack
            }
          }
          errorMessage(error.response.data.message, ()=>{});
        } else {
          error.response.data = { ...error.response.data,
            message : error.response.data.detail ? error.response.data.detail : error.response.data.error_description
          }
        }*/
        return Promise.reject(error);
      }
    )

    return () => {
      httpClient.interceptors.request.eject(reqInterceptor);
      httpClient.interceptors.response.eject(resInterceptor);
    }

  }, [])


  return children;
}

